<div class="user-management">
  <div class="change-password-form" *ngIf="mode === 'resetPassword'">
    <div class="change-password-form__loading" *ngIf="!resetLoaded">
      {{ content?.fields.resources | findResource: 'loading' }}
    </div>

    <form
      [formGroup]="changePasswordForm"
      class="change-password-form__form"
      (ngSubmit)="resetPassword()"
      *ngIf="canReset"
    >
      <h1>
        {{ content?.fields.resources | findResource: 'resetPasswordHeading'
        }}<span *ngIf="email">
          {{ content?.fields.resources | findResource: 'resetPasswordFor' }}
          {{ email }}</span
        >
      </h1>
      <div class="change-password-form__input-container">
        <input
          class="change-password-form__input"
          type="password"
          name="newPassword"
          formControlName="newPassword"
          [placeholder]="
            content?.fields.resources | findResource: 'passwordLabel'
          "
        />

        <span
          class="change-password-form__input-error"
          *ngIf="hasError(newPassword, 'required')"
        >
          {{ (globalContent$ | async)?.fields.inputValidationRequired }}
        </span>
        <span
          class="change-password-form__input-error"
          *ngIf="hasError(newPassword, 'minlength')"
        >
          {{ (globalContent$ | async)?.fields.inputValidationTooShort }}
        </span>
      </div>

      <div class="change-password-form__input-container">
        <input
          class="change-password-form__input"
          type="password"
          name="confirmPassword"
          formControlName="confirmPassword"
          [placeholder]="
            content?.fields.resources
              | findResource: 'passwordConfirmationLabel'
          "
        />
        <span
          class="change-password-form__input-error"
          *ngIf="hasError(confirmPassword, 'required')"
        >
          {{ (globalContent$ | async)?.fields.inputValidationRequired }}
        </span>
        <span
          class="change-password-form__input-error"
          *ngIf="hasError(confirmPassword, 'notSame')"
        >
          {{
            content?.fields.resources | findResource: 'inputValidationNotEqual'
          }}
        </span>
      </div>

      <div class="change-password-form__submit">
        <button
          class="change-password-form__submit-button"
          [ngClass]="{
            'change-password-form__submit-button--waiting': waiting
          }"
          [disabled]="waiting"
          type="submit"
        >
          {{ content?.fields.resources | findResource: 'changePasswordCTA' }}
        </button>
      </div>

      <div class="change-password-form__form-error" *ngIf="resetFormError">
        {{
          content?.fields.resources
            | findResource: 'changePasswordConfirmationError'
        }}
      </div>
    </form>

    <div class="change-password-form__form-error" *ngIf="resetCodeError">
      {{ content?.fields.resources | findResource: 'changePasswordCodeError' }}
    </div>
  </div>

  <div class="recover-email" *ngIf="mode === 'recoverEmail'">
    <div class="recover-email__loading" *ngIf="!recoverLoaded">
      {{ content?.fields.resources | findResource: 'loading' }}
    </div>
    <div class="recover-email__success" *ngIf="emailRecovered">
      <h1>
        {{
          content?.fields.resources
            | findResource: 'accountEmailRecoverConfirmation'
        }}
      </h1>
      <div class="recover-email__reset-password" *ngIf="resetEmailSent">
        {{ content?.fields.resources | findResource: 'pleaseResetPassword' }}
      </div>
      <div class="recover-email__email-error" *ngIf="resetEmailError">
        {{
          content?.fields.resources | findResource: 'resetPasswordEmailError'
        }}
      </div>
    </div>
    <div class="recover-email__error" *ngIf="recoverCodeError">
      <h1>
        {{
          content?.fields.resources
            | findResource: 'accountEmailRecoverCodeInvalid'
        }}
      </h1>
    </div>
  </div>

  <div class="verify-email" *ngIf="mode === 'verifyEmail'">
    <div class="verify-email__loading" *ngIf="!verifyLoaded">
      {{ content?.fields.resources | findResource: 'loading' }}
    </div>
    <div class="verify-email__success" *ngIf="verifyConfirm">
      {{ content?.fields.resources | findResource: 'verifyEmailSuccess' }}
    </div>
    <div class="verify-email__error" *ngIf="verifyError">
      {{ content?.fields.resources | findResource: 'verifyEmailError' }}
    </div>
  </div>
</div>
